<template>
    <div>
        <v-simple-table v-if="getSpecificPeriodsDiffs(diff.diffs, 'add&update').length > 0"
                        v-for="priceDiff in getSpecificPeriodsDiffs(diff.diffs, 'add&update')"
                        class="my-3">
            <tr>
                <td v-if="priceDiff.old === null" width="40%"
                    :style="'background-color:' + addColors.light">
                </td>

                <td v-else width="40%" :style="'background-color:' + getPeriodColors(priceDiff).light">
                    <price-period-diff-card :priceDiff="priceDiff" :data="priceDiff.old"></price-period-diff-card>
                </td>

                <td width="20%" :style="'background-color:' + getPeriodColors(priceDiff).light">
                    <icons-between-columns :diff="priceDiff"></icons-between-columns>
                </td>

                <td v-if="priceDiff.new === null" width="40%">
                </td>
                <td v-else width="40%" :style="'background-color:' + getPeriodColors(priceDiff).light">
                    <price-period-diff-card :priceDiff="priceDiff" :data="priceDiff.new"></price-period-diff-card>
                </td>
            </tr>
        </v-simple-table>

        <div v-if="getSpecificPeriodsDiffs(diff.diffs, 'delete').length > 0">
            <v-expansion-panels>
                <v-expansion-panel :style="'background-color:' + deleteColors.light">
                    <v-expansion-panel-header :style="'background-color:' + deleteColors.light">
                                <span class="text-danger">
                            <v-icon color="red">delete_outline</v-icon>
                            Les périodes tarifaire suivantes ont été supprimées :
                        </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                        <div class="d-flex">
                            <div v-for="priceDiff in getSpecificPeriodsDiffs(diff.diffs, 'delete')">
                                <price-period-diff-card :priceDiff="priceDiff"
                                                        :data="priceDiff.old"
                                                        class="mx-2"
                                ></price-period-diff-card>
                            </div>
                        </div>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </div>
    </div>
</template>

<script>

import IconsBetweenColumns from "./cardDiffsComponents/IconsBetweenColumns.vue"
import PricePeriodDiffCard from "./cardDiffsComponents/PricePeriodDiffCard.vue"
import { mapState } from "vuex"

export default {
    name: "PricePeriodFieldDiffs",
    props: ["diff"],
    components: {
        IconsBetweenColumns,
        PricePeriodDiffCard,
    },
    methods: {
        getSpecificPeriodsDiffs(diffs, type) {
            if (type === "add&update") {
                return diffs.filter(diff => diff.type === "ADDED" || diff.type === "UPDATED")
            } else if (type === "delete") {
                return diffs.filter(diff => diff.type === "DELETED")
            }
        },
        getPeriodColors(openingDiff) {
            if (openingDiff.old === null) {
                return this.addColors
            } else if (openingDiff.new !== null) {
                return this.updateColors
            } else {
                return this.deleteColors
            }
        },
    },
    computed: {
        ...mapState("sitAnswer", [
            "addColors",
            "updateColors",
            "deleteColors",
        ]),
    },
}
</script>